/* Athleia shop tools: colour swatches + quick size add on product cards, and Size / Colour / Activity / Fit filters on collections */
(function () {
  if (window.__astReady) return; window.__astReady = true;
  var cfgEl = document.getElementById('ast-config'); var CFG = {};
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) {}
  var FAMILIES = CFG.families || [];
  var HEX = CFG.colours || {};
  var GROUP = CFG.colourGroups || {};
  var ACTIVITIES = ['Run', 'Train', 'Yoga', 'Studio', 'Travel'];
  var SIZE_ORDER = ['XXS', 'XS', 'S', 'M', 'L', 'XL', 'XXL', '2XL', '3XL'];

  // ---------- data ----------
  var cache = {};
  function getProduct(handle) {
    if (cache[handle]) return cache[handle];
    var key = 'ast:' + handle;
    try { var s = sessionStorage.getItem(key); if (s) { cache[handle] = Promise.resolve(JSON.parse(s)); return cache[handle]; } } catch (e) {}
    cache[handle] = fetch('/products/' + handle + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw new Error(r.status); return r.json(); })
      .then(function (p) { try { sessionStorage.setItem(key, JSON.stringify(p)); } catch (e) {} return p; })
      .catch(function () { return null; });
    return cache[handle];
  }
  function optIndex(p, re) { for (var i = 0; i < p.options.length; i++) { var n = (p.options[i].name || p.options[i]).toString(); if (re.test(n)) return i; } return -1; }
  function colourIdx(p) { return optIndex(p, /colou?r/i); }
  function sizeIdx(p) { return optIndex(p, /siz/i); }
  function money(c) { return 'Rs. ' + (c / 100).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 }); }
  function tagVals(p, prefix) { return (p.tags || []).filter(function (t) { return t.indexOf(prefix) === 0; }).map(function (t) { return t.slice(prefix.length).trim(); }); }
  function coloursOf(p) {
    var ci = colourIdx(p), out = [];
    if (ci > -1) p.options[ci].values.forEach(function (v) { out.push(v); });
    tagVals(p, 'Colour:').forEach(function (v) { out.push(v); });
    return out;
  }
  function groupOf(c) { var k = String(c).toLowerCase(); return GROUP[k] || (c.charAt(0).toUpperCase() + c.slice(1)); }
  function hexOf(c) { return HEX[String(c).toLowerCase()] || '#cfcac2'; }
  function familyOf(handle) { for (var i = 0; i < FAMILIES.length; i++) if (FAMILIES[i].indexOf(handle) > -1) return FAMILIES[i]; return [handle]; }
  function handleFromCard(card) {
    var a = card.querySelector('.card__heading a[href*="/products/"], a.full-unstyled-link[href*="/products/"], a[href*="/products/"]');
    if (!a) return null; var m = a.getAttribute('href').match(/\/products\/([^/?#]+)/); return m ? decodeURIComponent(m[1]) : null;
  }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  // ---------- product cards ----------
  function entriesFor(handle) {
    // every colour option across the product family -> { handle, colour, product }
    return Promise.all(familyOf(handle).map(getProduct)).then(function (ps) {
      var list = [];
      ps.forEach(function (p) {
        if (!p) return;
        var ci = colourIdx(p);
        if (ci > -1) p.options[ci].values.forEach(function (v) { list.push({ product: p, colour: v, ci: ci }); });
        else list.push({ product: p, colour: (tagVals(p, 'Colour:')[0] || ''), ci: -1 });
      });
      return list;
    });
  }
  function variantFor(entry, size) {
    var p = entry.product, si = sizeIdx(p);
    return p.variants.find(function (v) {
      return (entry.ci < 0 || v.options[entry.ci] === entry.colour) && (si < 0 || v.options[si] === size);
    });
  }
  function imageFor(entry) {
    var p = entry.product;
    if (entry.ci > -1) { var v = p.variants.find(function (x) { return x.options[entry.ci] === entry.colour && x.featured_image; }); if (v && v.featured_image) return v.featured_image.src; }
    return p.featured_image ? (p.featured_image.indexOf('//') === 0 ? 'https:' + p.featured_image : p.featured_image) : null;
  }
  function sized(src, w) { if (!src) return src; src = src.replace(/^\/\//, 'https://'); return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w; }

  function enhanceCard(card) {
    if (card.dataset.ast) return; card.dataset.ast = '1';
    var handle = handleFromCard(card); if (!handle) return;
    card.querySelectorAll('.quick-add').forEach(function (q) { q.remove(); });
    entriesFor(handle).then(function (entries) {
      if (!entries.length) return;
      var startIdx = Math.max(0, entries.findIndex(function (e) { return e.product.handle === handle; }));
      var state = { i: startIdx };
      var infos = card.querySelectorAll('.card > .card__content .card__information, .card__content .card__information'); var info = infos[infos.length - 1] || card.querySelector('.card__content');
      var inner = card.querySelector('.card__inner');
      // swatches
      var multi = entries.filter(function (e) { return e.colour; }).length > 1;
      var sw = null;
      if (multi) {
        sw = document.createElement('div'); sw.className = 'ast-sw'; sw.setAttribute('role', 'radiogroup'); sw.setAttribute('aria-label', 'Colour');
        entries.forEach(function (e, i) {
          var b = document.createElement('button'); b.type = 'button'; b.className = 'ast-sw__dot'; b.setAttribute('role', 'radio');
          b.setAttribute('aria-checked', i === state.i ? 'true' : 'false'); b.setAttribute('aria-label', e.colour); b.title = e.colour;
          b.style.setProperty('--c', hexOf(e.colour)); b.dataset.i = i;
          sw.appendChild(b);
        });
        var count = document.createElement('span'); count.className = 'ast-sw__n'; count.textContent = entries.length + ' colours'; sw.appendChild(count);
        info && info.appendChild(sw);
        sw.addEventListener('click', function (ev) { var b = ev.target.closest('.ast-sw__dot'); if (!b) return; ev.preventDefault(); select(+b.dataset.i); });
        sw.addEventListener('mouseover', function (ev) { var b = ev.target.closest('.ast-sw__dot'); if (b && window.matchMedia('(hover: hover)').matches) preview(+b.dataset.i); });
        sw.addEventListener('mouseleave', function () { if (window.matchMedia('(hover: hover)').matches) preview(state.i); });
      }
      // quick add
      var qa = null;
      if (inner) {
        qa = document.createElement('div'); qa.className = 'ast-qa';
        inner.appendChild(qa);
        var plus = document.createElement('button'); plus.type = 'button'; plus.className = 'ast-qa__open'; plus.setAttribute('aria-label', 'Quick add'); plus.setAttribute('aria-expanded', 'false');
        plus.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg>';
        inner.appendChild(plus);
        plus.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); var on = !card.classList.contains('ast-open'); closeAll(); card.classList.toggle('ast-open', on); plus.setAttribute('aria-expanded', on); if (on) { var f = qa.querySelector('button:not([disabled])'); f && f.focus(); } });
        qa.addEventListener('click', function (ev) { ev.preventDefault(); ev.stopPropagation(); var b = ev.target.closest('[data-v]'); if (b && !b.disabled) add(b); });
        // the image sits above the card link so the quick add panel is tappable on every browser; open the product on image taps
        inner.addEventListener('click', function (ev) {
          if (ev.target.closest('.ast-qa, .ast-qa__open, a, button')) return;
          if (card.classList.contains('ast-open')) { closeAll(); return; }
          var a = card.querySelector('.card__heading a[href*="/products/"]') || card.querySelector('a[href*="/products/"]');
          if (a) window.location.href = a.href;
        });
      }
      function renderQA() {
        if (!qa) return; var e = entries[state.i], p = e.product, si = sizeIdx(p);
        if (si < 0) {
          var v0 = p.variants[0];
          qa.innerHTML = '<p class="ast-qa__label">Quick add</p><div class="ast-qa__row"><button type="button" class="ast-qa__one" data-v="' + v0.id + '"' + (v0.available ? '' : ' disabled') + '>' + (v0.available ? 'Add to bag' : 'Sold out') + '</button></div>';
          return;
        }
        var sizes = p.options[si].values.slice().sort(function (a, b) { return SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b); });
        qa.innerHTML = '<p class="ast-qa__label">Quick add' + (e.colour ? ' · ' + esc(e.colour) : '') + '</p><div class="ast-qa__row">' + sizes.map(function (s) {
          var v = variantFor(e, s); if (!v) return '';
          return '<button type="button" data-v="' + v.id + '"' + (v.available ? '' : ' disabled aria-label="' + esc(s) + ' sold out"') + '>' + esc(s) + '</button>';
        }).join('') + '</div>';
      }
      function setImage(src) {
        if (!src) return; var imgs = card.querySelectorAll('.card__media img');
        if (imgs[0]) { imgs[0].removeAttribute('srcset'); imgs[0].removeAttribute('sizes'); imgs[0].src = sized(src, 720); }
        if (imgs[1]) imgs[1].style.opacity = '0';
      }
      function preview(i) { setImage(imageFor(entries[i])); }
      function select(i) {
        state.i = i; var e = entries[i], p = e.product;
        if (sw) sw.querySelectorAll('.ast-sw__dot').forEach(function (d, k) { d.setAttribute('aria-checked', k === i ? 'true' : 'false'); });
        preview(i);
        var v = e.ci > -1 ? p.variants.find(function (x) { return x.options[e.ci] === e.colour; }) : p.variants[0];
        var url = '/products/' + p.handle + (e.ci > -1 && v ? '?variant=' + v.id : '');
        card.querySelectorAll('a[href*="/products/"]').forEach(function (a) { a.setAttribute('href', url); });
        card.querySelectorAll('.card__heading a').forEach(function (t) { t.textContent = p.title; });
        var pr = card.querySelector('.price-item--regular, .price-item--sale, .price__regular .price-item');
        if (pr && v) pr.textContent = money(v.price);
        renderQA();
      }
      function add(btn) {
        var label = btn.textContent, id = +btn.dataset.v;
        var cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        var body = { items: [{ id: id, quantity: 1 }] };
        if (cart && typeof cart.getSectionsToRender === 'function') {
          body.sections = cart.getSectionsToRender().map(function (s) { return s.id; }); body.sections_url = window.location.pathname;
          if (typeof cart.setActiveElement === 'function') cart.setActiveElement(document.activeElement);
        }
        btn.disabled = true; btn.classList.add('is-busy');
        fetch((window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add') + '.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body: JSON.stringify(body) })
          .then(function (r) { return r.json(); })
          .then(function (res) {
            if (res.status) throw new Error(res.description || 'Could not add');
            var lines = res.items || [res];
            if (window.publish && window.PUB_SUB_EVENTS) { try { window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'athleia-quick-add', productVariantId: id, cartData: res }); } catch (e) {} }
            if (cart && typeof cart.renderContents === 'function' && res.sections) { cart.classList.remove('is-empty'); cart.renderContents({ key: lines[lines.length - 1].key, sections: res.sections }); }
            else if (!cart) { window.location.href = '/cart'; return; }
            btn.textContent = '✓'; card.classList.remove('ast-open');
            setTimeout(function () { btn.textContent = label; btn.disabled = false; btn.classList.remove('is-busy'); }, 1600);
          })
          .catch(function (err) { btn.textContent = label; btn.disabled = false; btn.classList.remove('is-busy'); var l = qa.querySelector('.ast-qa__label'); if (l) l.textContent = err.message; });
      }
      renderQA();
      card.dataset.astReady = '1';
      card.dispatchEvent(new CustomEvent('ast:ready', { bubbles: true }));
    });
  }
  function closeAll() { document.querySelectorAll('.card-wrapper.ast-open').forEach(function (c) { c.classList.remove('ast-open'); var b = c.querySelector('.ast-qa__open'); b && b.setAttribute('aria-expanded', 'false'); }); }
  document.addEventListener('click', function (e) { if (!e.target.closest('.ast-qa, .ast-qa__open')) closeAll(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeAll(); });

  function scan(root) { (root || document).querySelectorAll('.card-wrapper').forEach(function (c) { if (c.querySelector('a[href*="/products/"]')) enhanceCard(c); }); }

  // ---------- collection filters ----------
  var F = null;
  function initFilters() {
    if (CFG.template !== 'collection') return;
    var grid = document.getElementById('ProductGridContainer'); if (!grid) return;
    F = { sel: { size: [], colour: [], activity: [], fit: [], stock: [] }, bar: null };
    try { var h = new URLSearchParams(location.hash.slice(1)); ['size', 'colour', 'activity', 'fit', 'stock'].forEach(function (k) { if (h.get(k)) F.sel[k] = h.get(k).split(','); }); } catch (e) {}
    F.bar = document.createElement('div'); F.bar.className = 'ast-f'; F.bar.setAttribute('aria-label', 'Filters');
    var anchor = document.querySelector('.facets-container') || grid;
    anchor.parentNode.insertBefore(F.bar, anchor);
    buildFilters();
  }
  function cardsInGrid() { return Array.prototype.slice.call(document.querySelectorAll('#ProductGridContainer .card-wrapper')); }
  function buildFilters() {
    var cards = cardsInGrid();
    Promise.all(cards.map(function (c) { var h = handleFromCard(c); return h ? getProduct(h) : Promise.resolve(null); })).then(function (ps) {
      var opts = { size: {}, colour: {}, activity: {}, fit: {} };
      ps.forEach(function (p, i) {
        if (!p) return; cards[i]._astP = p;
        var si = sizeIdx(p); if (si > -1) p.options[si].values.forEach(function (s) { opts.size[s] = 1; });
        coloursOf(p).forEach(function (c) { opts.colour[groupOf(c)] = 1; });
        (p.tags || []).forEach(function (t) { if (ACTIVITIES.indexOf(t) > -1) opts.activity[t] = 1; });
        tagVals(p, 'Fit:').forEach(function (f) { opts.fit[f] = 1; });
      });
      F.opts = {
        size: Object.keys(opts.size).sort(function (a, b) { return SIZE_ORDER.indexOf(a) - SIZE_ORDER.indexOf(b); }),
        colour: Object.keys(opts.colour).sort(),
        activity: ACTIVITIES.filter(function (a) { return opts.activity[a]; }),
        fit: ['Second-skin', 'Fitted', 'Regular', 'Relaxed'].filter(function (f) { return opts.fit[f]; }).concat(Object.keys(opts.fit).filter(function (f) { return ['Second-skin', 'Fitted', 'Regular', 'Relaxed'].indexOf(f) < 0; }))
      };
      renderBar(); apply();
    });
  }
  var LABELS = { size: 'Size', colour: 'Colour', activity: 'Activity', fit: 'Fit' };
  function renderBar() {
    var open = F.open || '';
    var html = '<div class="ast-f__row" role="toolbar" aria-label="Filter products">';
    ['size', 'colour', 'activity', 'fit'].forEach(function (k) {
      if (!F.opts[k].length || (k !== 'size' && F.opts[k].length < 2 && !F.sel[k].length)) return;
      var n = F.sel[k].length;
      html += '<button type="button" class="ast-f__pill' + (n ? ' is-active' : '') + '" data-open="' + k + '" aria-expanded="' + (open === k) + '" aria-controls="ast-f-panel">' + LABELS[k] + (n ? ' <span class="ast-f__n">' + n + '</span>' : '') + '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="m6 9 6 6 6-6"/></svg></button>';
    });
    html += '<button type="button" class="ast-f__pill' + (F.sel.stock.length ? ' is-active' : '') + '" data-toggle-stock aria-pressed="' + (F.sel.stock.length ? 'true' : 'false') + '">In stock</button>';
    html += '</div>';
    if (open) {
      html += '<div class="ast-f__panel" id="ast-f-panel" role="group" aria-label="' + LABELS[open] + '">' + F.opts[open].map(function (v) {
        var on = F.sel[open].indexOf(v) > -1;
        var dot = open === 'colour' ? '<span class="ast-f__dot" style="--c:' + hexOf(v) + '"></span>' : '';
        return '<button type="button" class="ast-f__opt' + (open === 'size' ? ' is-size' : '') + '" data-k="' + open + '" data-v="' + esc(v) + '" aria-pressed="' + on + '">' + dot + esc(v) + '</button>';
      }).join('') + '</div>';
    }
    var chips = [];
    ['size', 'colour', 'activity', 'fit'].forEach(function (k) { F.sel[k].forEach(function (v) { chips.push('<button type="button" class="ast-f__chip" data-k="' + k + '" data-v="' + esc(v) + '" aria-label="Remove ' + esc(v) + '">' + esc(v) + ' <span aria-hidden="true">×</span></button>'); }); });
    if (F.sel.stock.length) chips.push('<button type="button" class="ast-f__chip" data-toggle-stock aria-label="Remove In stock">In stock <span aria-hidden="true">×</span></button>');
    html += '<div class="ast-f__meta"><p class="ast-f__count" aria-live="polite" data-count></p>' + (chips.length ? '<div class="ast-f__chips">' + chips.join('') + '<button type="button" class="ast-f__clear" data-clear>Clear all</button></div>' : '') + '</div>';
    F.bar.innerHTML = html;
  }
  function match(p, k, vals) {
    if (!vals.length) return true;
    if (k === 'size') { var si = sizeIdx(p); if (si < 0) return false; return p.variants.some(function (v) { return vals.indexOf(v.options[si]) > -1 && (!F.sel.stock.length || v.available); }); }
    if (k === 'colour') return coloursOf(p).some(function (c) { return vals.indexOf(groupOf(c)) > -1; });
    if (k === 'activity') return (p.tags || []).some(function (t) { return vals.indexOf(t) > -1; });
    if (k === 'fit') return tagVals(p, 'Fit:').some(function (f) { return vals.indexOf(f) > -1; });
    return true;
  }
  function apply() {
    if (!F) return;
    var cards = cardsInGrid(), shown = 0;
    cards.forEach(function (c) {
      var p = c._astP, li = c.closest('li') || c, ok = true;
      if (p) { ['size', 'colour', 'activity', 'fit'].forEach(function (k) { if (!match(p, k, F.sel[k])) ok = false; }); if (F.sel.stock.length && !p.available) ok = false; }
      li.hidden = !ok; if (ok) shown++;
    });
    var total = cards.length, cnt = F.bar.querySelector('[data-count]');
    if (cnt) cnt.textContent = (shown === total ? total : shown + ' of ' + total) + (total === 1 ? ' product' : ' products');
    var empty = document.getElementById('ast-f-empty');
    if (!shown) {
      if (!empty) { empty = document.createElement('div'); empty.id = 'ast-f-empty'; empty.className = 'ast-f__empty'; empty.innerHTML = '<p>No products match these filters.</p><button type="button" class="ast-f__clear" data-clear>Clear filters</button>'; var g = document.getElementById('ProductGridContainer'); g.parentNode.insertBefore(empty, g.nextSibling); empty.addEventListener('click', function (e) { if (e.target.closest('[data-clear]')) clearAll(); }); }
    } else if (empty) empty.remove();
    var h = new URLSearchParams(); Object.keys(F.sel).forEach(function (k) { if (F.sel[k].length) h.set(k, F.sel[k].join(',')); });
    var hs = h.toString(); history.replaceState(null, '', location.pathname + location.search + (hs ? '#' + hs : ''));
  }
  function clearAll() { Object.keys(F.sel).forEach(function (k) { F.sel[k] = []; }); F.open = ''; renderBar(); apply(); }
  document.addEventListener('click', function (e) {
    if (!F || !F.bar) return;
    var t = e.target.closest('.ast-f [data-open], .ast-f [data-k], .ast-f [data-toggle-stock], .ast-f [data-clear]');
    if (!t) { if (F.open && !e.target.closest('.ast-f')) { F.open = ''; renderBar(); } return; }
    if (t.dataset.open) { F.open = F.open === t.dataset.open ? '' : t.dataset.open; renderBar(); var first = F.bar.querySelector('.ast-f__opt'); if (first && F.open) first.focus(); else { var p = F.bar.querySelector('[data-open="' + t.dataset.open + '"]'); p && p.focus(); } return; }
    if (t.hasAttribute('data-clear')) { clearAll(); return; }
    if (t.hasAttribute('data-toggle-stock')) { F.sel.stock = F.sel.stock.length ? [] : ['1']; renderBar(); apply(); return; }
    if (t.dataset.k) {
      var k = t.dataset.k, v = t.dataset.v, arr = F.sel[k], i = arr.indexOf(v);
      if (i > -1) arr.splice(i, 1); else arr.push(v);
      var wasChip = t.classList.contains('ast-f__chip');
      renderBar(); apply();
      if (!wasChip) { var same = F.bar.querySelector('.ast-f__opt[data-v="' + CSS.escape(v) + '"]'); same && same.focus(); }
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && F && F.open) { var k = F.open; F.open = ''; renderBar(); var p = F.bar.querySelector('[data-open="' + k + '"]'); p && p.focus(); } });

  // ---------- boot + keep up with re-rendered grids (sorting, related products, etc.) ----------
  function boot() {
    scan(); initFilters();
    var pending = false;
    new MutationObserver(function (muts) {
      if (pending) return; pending = true;
      setTimeout(function () {
        pending = false; scan();
        if (F && F.bar) {
          if (!document.body.contains(F.bar)) { var g = document.getElementById('ProductGridContainer'); if (g) { var a = document.querySelector('.facets-container') || g; a.parentNode.insertBefore(F.bar, a); } }
          var cards = cardsInGrid(); if (cards.some(function (c) { return !c._astP; })) buildFilters();
        }
      }, 60);
    }).observe(document.body, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
